import React from "react";
import CaseStudys from "../index";
import styles from "./styles.module.scss";
import kudlabuilders from "../../../assets/casestudy/kudlabuildersbanner.png";

import kudlabuilders1img from "../../../assets/casestudy/kudlabuilders1img.png";
import kudlabuilders2img from "../../../assets/casestudy/kudlabuilders2img.png";
import kudlabuilders3img from "../../../assets/casestudy/kudlabuilders3img.png";
import KumarPhotography from "../../../assets/img/KumarPhotoGraphy.png";
import Mongodbicon from "../../../assets/img/mongodbicon.svg";
import Nodeicon from "../../../assets/img/nodeicon.svg";
import Reacticon from "../../../assets/img/reacticon.svg";
import Expressicon from "../../../assets/img/expressicon.svg";

import scentabook1stimg from "../../../assets/casestudy/scentabook1stimg.webp";
import aryafireandsafety1img from "../../../assets/casestudy/aryafireandsafety1img.png";

const KudlaBuilders = () => {
  const caseStudiesB = [
    {
      image: scentabook1stimg,
      title: "ScentaBook",
      category: "Website Design",
      pagelink: "/scenta-book",
      link: "https://scentabook.com/",
    },
    {
      image: aryafireandsafety1img,
      title: "AryaFireandSafety",
      category: "Website Design",
      pagelink: "/aryafire-and-safety",
      link: "https://aryafireandsafety.com/",
    },
  ];
  const servicesB = [
    { label: "UI & UX Design", link: "https://metasoft.ae/services" },
    { label: "Web Development", link: "https://metasoft.ae/services" },
    { label: "Performance Optimization", link: "https://metasoft.ae/services" },
    { label: "SEO", link: "https://metasoftdm.com/marketing-solutions/seo/" },
  ];
  return (
    <CaseStudys
      title="KudlaBuilders"
      caseStudies={caseStudiesB}
      subtitle="Building Dreams in Mangaluru’s Heart"
      header="Building Dreams in Mangaluru’s Heart"
      websiteUrl="https://kudlabuilders.com/"
      industry="Real Estate & Property Development"
      services={servicesB}
      description={
        <>
          <span>KudlaBuilders </span>Kudla Builders is a forward-thinking real
          estate brand rooted in Mangaluru, dedicated to creating valuable
          residential and commercial plot opportunities for modern buyers. To
          showcase their credibility, vision, and commitment to quality
          development, we crafted a clean and intuitive digital presence that
          reflects both their local heritage and professional strength. The
          website highlights their projects, values, and customer-centric
          approach, offering a seamless browsing experience that builds trust
          and helps users explore plots with clarity and confidence—bringing
          together transparency, design, and reliable information in one
          cohesive platform.
        </>
      }
      objective={{
        heading:
          "Designing a Clear and Credible Online Experience for Kudla Builders",
        content: (
          <>
            <p className={styles.projectText}>
              The objective of the Kudla Builders website project was to create
              a modern, trust-driven digital presence that reflects the brand’s
              commitment to quality land development and customer-focused real
              estate solutions. Our goal was to design a clean, intuitive
              platform that showcases their residential and commercial plot
              offerings with clarity, transparency, and impact. This project
              aimed to communicate Kudla Builders’ credibility, highlight their
              heritage in Mangaluru, and provide users with a seamless browsing
              experience that simplifies decision-making—ultimately helping
              potential buyers explore projects confidently and fostering strong
              engagement in a highly competitive real estate market.
            </p>
          </>
        ),
      }}
      process={{
        heading:
          "How We Developed a Clean, Intuitive, and Professional Web Experience",
        content: (
          <>
            <p className={styles.projectText}>
              The project began with a thorough understanding of Kudla Builders’
              brand values, development vision, and the expectations of modern
              property buyers in Mangaluru. With this foundation, we mapped a
              user journey focused on clarity, trust, and effortless exploration
              of available plots and projects. During the design phase, we
              prioritized clean layouts, structured information flow, and
              visuals that reflect professionalism and regional authenticity.
              Our development process centered on building a fast, responsive,
              and user-friendly website that ensures smooth navigation, quick
              access to project details, and optimal mobile performance. Regular
              reviews with the client helped maintain alignment throughout the
              process, and extensive testing ensured a polished, reliable, and
              confidence-boosting experience at launch.
            </p>
          </>
        ),
      }}
      impact={{
        heading:
          "How the New Web Experience Elevated Kudla Builders’ Brand Perception",
        content: (
          <>
            <p className={styles.projectText}>
              The launch of the Kudla Builders website significantly
              strengthened the brand’s digital presence, giving potential buyers
              a clear and trustworthy way to explore available plots and
              projects. The clean layout, intuitive navigation, and
              well-structured content improved user understanding while building
              confidence in the brand’s credibility. With faster access to
              project details, better mobile performance, and an overall
              smoother browsing experience, the website has helped increase user
              engagement and broaden reach within the Mangaluru real estate
              market. As a result, the platform now serves as a reliable and
              professional touchpoint that supports informed decision-making and
              enhances the brand’s visibility and reputation.
            </p>
          </>
        ),
      }}
      conclusion={{
        heading: "Wrapping Up the Project",
        content: (
          <>
            <p className={styles.projectText}>
              In conclusion, the Kudla Builders website successfully captured
              the brand’s commitment to transparent, reliable, and
              customer-centric real estate development. By combining a clean
              visual identity with seamless functionality, the platform now
              serves as a powerful tool for showcasing projects, building trust,
              and guiding potential buyers through informed decision-making. The
              project not only elevated the brand’s digital presence but also
              strengthened Kudla Builders’ position within the competitive
              Mangaluru real estate market, supporting their continued growth
              and long-term vision.
            </p>
          </>
        ),
      }}
      heroImage={kudlabuilders} // Add the hero image
      projectImage={kudlabuilders1img}
      projectImage2={kudlabuilders2img}
      projectImage3={kudlabuilders3img}
      // Add the project image
      technologies={[
        { name: "MongoDB", icon: Mongodbicon },
        { name: "Node.js", icon: Nodeicon },
        { name: "React", icon: Reacticon },
        { name: "Express.js", icon: Expressicon },
      ]} // Add the technologies used
      timescale="On-going" // Add the timescale
      launchDate="Aug 2025" // Add the launch date
    />
  );
};

export default KudlaBuilders;
